import React, { useRef, useState } from 'react';
import { useFramePositioning } from '../hooks/useFramePositioning.js';
import { cx } from '../utils/cx.js';
import { RootPortal } from './RootPortal';

import { FoodItemList } from './single-product/food/FoodItemList';
import { translate } from '../utils/wp.js';

function FoodDialog({visible, guests, food, onConfirm, onClose}) {
    const dialog = useRef(null);

    const {center} = useFramePositioning(dialog);

    const [choices, setChoices] = useState({
        meat: {val: 0, alias: ''},
        fish: {val: 0, alias: ''},
        veg: {val: 0, alias: ''},
    });

    const isComplete = guests -
        choices.meat.val -
        choices.fish.val -
        choices.veg.val ===
        0;

    const types = ['meat', 'fish', 'veg'];

    const onChangeChoices = (value, type, alias) =>
        setChoices({
            ...choices,
            [types[type]]: {...choices[types[type]], val: value, alias},
        });

    return (
        <RootPortal>
            <div
                className={cx(
                    'fixed inset-0 z-[1] bg-black/30 flex items-center justify-center',
                    visible ? 'visible' : 'hidden',
                )}
            >
                <div
                    className="food-dialog flex flex-col flex-start overscroll-contain overflow-hidden bg-white rounded-lg fixed left-1/2 -translate-x-1/2 w-[676px] max-w-[calc(90%)] h-[80vh] max-h-[570px]"
                    ref={dialog}
                    style={{
                        top: center,
                    }}
                >
                    <div className="p-4 flex items-center justify-between border-b border-black/10 md:text-sm">
                        <div className="flex items-center gap-x-2">
                            <i className="icon-restaurant text-primary text-[22px]"></i>
                            <span className="text-base font-semibold">
                                {translate('food_dialog_title')}
                            </span>
                        </div>
                        <button
                            className="block icon-plus rotate-45 text-[20px]"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div className="p-4 md:text-[13px] md:leading-[20px] text-black/50">
                        {translate('food_dialog_content')}
                    </div>
                    <div className="content flex-1 px-4 overflow-y-auto">
                        <FoodItemList
                            small={true}
                            food={food}
                            choices={choices}
                            max={guests}
                            onChange={onChangeChoices}
                        />
                    </div>
                    <div className="w-full mt-auto p-4">
                        <button
                            className={cx(
                                'w-full flex items-center justify-center gap-x-2 rounded-full px-6 py-4 text-xs font-bold text-primarytext',
                                isComplete ? 'bg-primary' : 'bg-disabled',
                            )}
                            disabled={!isComplete}
                            onClick={() => onConfirm(choices)}
                        >
                            {translate('food_confirm')}
                        </button>
                    </div>
                </div>
            </div>
        </RootPortal>
    )
        ;
}

export { FoodDialog };
